import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import bigIntSupport from 'dayjs/plugin/bigIntSupport'
import utc from 'dayjs/plugin/utc'

import { exhaustiveGuard } from '@jotta/utils/exhaustive'

// fromTimestampNanos passes bigint to dayjs.utc, so this module must not
// rely on other modules having extended these plugins as a side effect
dayjs.extend(bigIntSupport)
dayjs.extend(utc)

import type { TimelineRowDataV2 } from './groupV2'

export function timestampMillisToNanos(timestampMillis: number) {
  return BigInt(timestampMillis) * 1_000_000n
}

export function toNanos(day: Dayjs) {
  return timestampMillisToNanos(day.valueOf())
}

export function nanosFromRow(row: TimelineRowDataV2): bigint {
  switch (row.content) {
    case 'divider':
      return row.timestampNanos
    case 'row':
      return row.elements[Math.floor(row.elements.length / 2)].timestampNanos
    case 'header':
      return timestampMillisToNanos(row.day)
    default:
      return exhaustiveGuard(row)
  }
}

export function fromTimestampNanos(timestampNanos: bigint) {
  return dayjs.utc(timestampNanos / 1_000_000n)
}

export function capturedDay(day: Dayjs) {
  return day.startOf('day').valueOf()
}

export function capturedDayFromNanos(timestampNanos: bigint) {
  return capturedDay(fromTimestampNanos(timestampNanos))
}
